import { FC, ReactNode } from 'react'
import { DocumentoPrevisto } from '../../core/montagem/documentos'
import { rotuloCatalogo } from '../../core/montagem/itens'
import styles from '../../Prescricao.module.scss'
import { SeloSncr, SeloValidade } from '../comum/Selos'
import { useRotulos } from '../comum/useRotulos'

/** Cabeçalho do documento que um grupo de itens vai gerar, com validade e numeração SNCR. */
export const GrupoDocumento: FC<{ documento: DocumentoPrevisto; children: ReactNode }> = ({
  documento,
  children,
}) => {
  const { t, tituloDocumento } = useRotulos()
  const idTitulo = `grupo-${documento.chave}`

  return (
    <section className={styles.grupo} aria-labelledby={idTitulo}>
      <div className='d-flex flex-wrap align-items-center gap-2 mb-3'>
        <h3 id={idTitulo} className='fs-6 fw-bold m-0'>
          {tituloDocumento(documento)}
        </h3>
        {documento.validadeDias && (
          <SeloValidade
            texto={t('prescricao.documento.validade_dias', { dias: documento.validadeDias })}
          />
        )}
        {documento.sncr && <SeloSncr tipo={documento.sncr} />}
      </div>
      {documento.itensRetencao.length > 0 && (
        <p className={`fs-7 mb-3 ${styles.textoSecundario}`}>
          {t('prescricao.documento.nota_retencao', {
            itens: documento.itensRetencao.map((item) => rotuloCatalogo(item.catalogo)).join(', '),
            quantidade: documento.itensRetencao.length,
          })}
        </p>
      )}
      <div className='d-flex flex-column gap-3'>{children}</div>
    </section>
  )
}
